import axios from "@/http";

class Auth {
  /* 角色全部菜单权限（树状） */
  static getAllMenuAuthTree() {
    const url = `/oa/api/biz/role/authority/all/tree`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 用户全部权限（树状） */
  static getUserAllAuthTree() {
    const url = `/oa/api/pc/manager/list/authority/by/tree`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 用户拥有的菜单权限（树状） */
  static getUserMenuAuthTree() {
    const url = `/oa/api/pc/manager/list/manager/authority/by/tree`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Auth